import { useMetadataTagsListQuery } from "entities/metadataTags/queries/useMetadataTagsListQuery";
import { MetadataTag } from "entities/metadataTags/types";
import { MetadataTagPrimaryType } from "entities/tagTypes/types";
import keyBy from "lodash/keyBy";
import { useMemo } from "react";
import { PrimaryTag, TagBlock, TagOption } from "../type";

type Props = {
  id: string;
  primaryTagId: PrimaryTag | null;
  tagBlocks: TagBlock[];
};

export const useMetadataTagsOptions = ({
  id,
  primaryTagId,
  tagBlocks,
}: Props) => {
  const { data: metadataTags = [] } = useMetadataTagsListQuery();

  const groupedRawMetadataTags: Record<PrimaryTag, MetadataTag> = useMemo(
    () => keyBy(metadataTags, "primaryTag"),
    [metadataTags],
  );

  const metadataPrimaryTagOptions =
    metadataTags
      ?.filter((tag) => {
        const isAlreadySelected = tagBlocks.some(
          (block) => block.id !== id && block.primaryTagId === tag.primaryTag,
        );

        return (
          !isAlreadySelected && tag.type === MetadataTagPrimaryType.DROPDOWN
        );
      })
      .map((tag) => ({
        value: tag.primaryTag,
        label: tag.primaryTag,
      })) ?? [];

  const metadataSecondaryTagOptions: TagOption[] = primaryTagId
    ? (groupedRawMetadataTags[primaryTagId]?.secondaryTags?.map(
        (secondaryTag) => ({
          id: secondaryTag,
          name: secondaryTag,
        }),
      ) ?? [])
    : [];

  return {
    metadataSecondaryTagOptions,
    metadataPrimaryTagOptions,
  };
};
